import { Button } from '@e2n/ui';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigateToDate } from '../../hooks/useNavigateToDate';
import { YearMonthParams } from '@/domain/termine/type';

export function YearMonthPopoverContent({
  currentMonthAndYear,
  onSelect,
}: {
  currentMonthAndYear?: YearMonthParams;
  onSelect: () => void;
}) {
  const switchToDate = useNavigateToDate();
  const [displayedYear, setDisplayedYear] = useState(
    Number(currentMonthAndYear.year),
  );
  const selectedMonth = Number(currentMonthAndYear.month);

  const handlePrevYear = () => setDisplayedYear((year) => year - 1);
  const handleNextYear = () => setDisplayedYear((year) => year + 1);

  const handleMonthSelect = (monthIndex: number) => {
    const selectedDate = dayjs().year(displayedYear).month(monthIndex).date(1);
    switchToDate(selectedDate);
    onSelect();
  };
  const monthNames = Array.from({ length: 12 }, (_, idx) =>
    dayjs().locale('de').month(idx).format('MMM').slice(0, 3),
  );

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex w-full items-center justify-between">
        <Button onClick={handlePrevYear} variant="ghost-primary" size="icon">
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <div className="text-sm font-semibold">{displayedYear}</div>
        <Button onClick={handleNextYear} size="icon" variant="ghost-primary">
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {monthNames.map((monthName, idx) => {
          const isSelected =
            displayedYear === Number(currentMonthAndYear.year) &&
            selectedMonth === idx + 1;
          return (
            <Button
              key={idx}
              onClick={() => handleMonthSelect(idx)}
              className="font-normal"
              size="sm"
              variant={isSelected ? 'default' : 'ghost'}>
              {monthName}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
